/*
 * BigFlipLoading
 *
 * Big Flip logo animation when Big Flip page is loaded.
 */

import Lottie from "src/components/Lottie";
import { LoadingWrapper } from "./BigFlipLoading.styled";

import BigFlipLoaderLottie from "src/assets/animations/loader-big-flip.lottie";

function BigFlipLoading() {
  return (
    <LoadingWrapper>
      <Lottie src={BigFlipLoaderLottie} height={200} width={180} />
    </LoadingWrapper>
  );
}

export default BigFlipLoading;
